var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('start-membership'),_c('div',{staticClass:"row"},_vm._l((_vm.limitedThemes),function(theme,index){return _c('div',{key:theme.id,staticClass:"col-12 col-md text-truncate",on:{"click":function($event){return _vm.onThemeClicked(index)}}},[_c('theme-box',{attrs:{"number":index + 1,"title":theme.title}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }